import { createTranslations } from '@npco/utils-translations'

export const accountNameAndInterestCellTranslations = createTranslations({
  interest: '{interest}% p.a.',
  tooltip: 'Your current variable interest rate',
})
